export default {
  //isLoggedIn: () => true,
  isLoggedIn: (state) => !!state.token,
  authStatus: (state) => state.status,
  accesslist: (state) => state.access,
  userRole: (state) => state.role,
  accountUserSatatus: (state) => state.accountStatus,
  token: (state) => state.token,
  token_type: (state) => state.token_type,
  getAvailableFiatAssets: (state) => {
    return state.assets.filter((asset) => asset.fiat && asset.available);
  },
  getAvailableNoneFiatAssets: (state) => {
    return state.assets.filter((asset) => !asset.fiat && asset.available);
  },
  getAssets(state) {
    return state.assets
  },


  // Access management:
  isSuperAdmin: (state) => {
    return localStorage.getItem('role') === 'SuperAdmin';
  },
  isManagerAdmin: (state) => {
    return localStorage.getItem('role') === 'ManagerAdmin';
  },
  isApprovingManager: (state) => {
    return localStorage.getItem('role') === 'ApprovingManager';
  },
  isOperator: (state) => {
    return localStorage.getItem('role') === 'Operator';
  },

};
